import script from "./MediaContent.vue?vue&type=script&lang=ts&setup=true"
export * from "./MediaContent.vue?vue&type=script&lang=ts&setup=true"

import "./MediaContent.vue?vue&type=style&index=0&id=7c5e9af0&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c5e9af0"]])

export default __exports__